import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidationErrors, UntypedFormGroup } from '@angular/forms';

// form directive which adds an error to the second control if 2 controls values don't match
// usage:
// <form [appMustMatch]="['inputPassword', 'inputPasswordmatch']" ...
// @if (inputPasswordmatch.errors.mustMatch) { <div ...

@Directive({
  selector: '[appMustMatch]',
  providers: [{provide: NG_VALIDATORS, useExisting: MustMatchDirective, multi: true}],
  standalone: false
})
export class MustMatchDirective implements Validator {
  @Input('appMustMatch') mustMatch: string[] = [];

  validate(formGroup: UntypedFormGroup): ValidationErrors {
    const control = formGroup.controls[this.mustMatch[0]];
    const matchingControl = formGroup.controls[this.mustMatch[1]];

    if (!control || !matchingControl) {
      return null;
    }

    // return null if another validator has already found an error on the matchingControl
    if (matchingControl.errors && !matchingControl.errors.mustMatch) {
      return null;
    }

    // set error on matchingControl if validation fails
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({mustMatch: true});
    } else {
      matchingControl.setErrors(null);
    }
    return null;
  }
}
